module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row top-button-row"
  }, [_c('div', {
    staticClass: "large-12 columns"
  }, [_c('div', {
    staticClass: "large-2 large-offset-10"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'pageCreate'
      }
    }
  }, [_c('button', {
    staticClass: "full-width"
  }, [_vm._v("Nouvelle Page")])])], 1)])]), _vm._v(" "), (_vm.allFilteredPages.length === 0) ? _c('div', {
    staticClass: "panel-content"
  }, [_c('spinner')], 1) : _c('div', {
    staticClass: "row",
    attrs: {
      "id": "news-list-page"
    }
  }, [_c('div', {
    staticClass: "large-12 columns top"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-content"
  }, [_vm._l((_vm.allFilteredPages), function(item, index) {
    return _c('div', {
      staticClass: "news-list"
    }, [_c('div', {
      staticClass: "row columns"
    }, [_c('div', {
      staticClass: "medium-12 columns news-list-title"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "large-9 columns news-header"
    }, [_c('img', {
      staticClass: "page-league",
      attrs: {
        "src": item.featured_club.icon_path,
        "alt": ""
      }
    }), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: 'pageDetail',
          params: {
            id: item.id.toString()
          }
        }
      },
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }), _vm._v(" "), _c('p', [_c('span', [_c('i', {
      staticClass: "fa fa-calendar",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("le " + _vm._s(_vm._f("formatDate")(item.publish_date)))]), _vm._v(" "), _c('span', [_c('i', {
      staticClass: "fa fa-comments",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(_vm._s(item.comments_count) + " commentaires")])])], 1)])])]), _vm._v(" "), (index != (_vm.allFilteredPages.length - 1)) ? _c('hr') : _vm._e()])
  }), _vm._v(" "), _vm._m(0)], 2)])])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-10 large-centered"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "large-12 columns"
  }, [_c('div', {
    staticClass: "large-2 large-offset-10"
  }, [_c('a', [_c('button', {
    staticClass: "full-width"
  }, [_vm._v("Nouvelle Page")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d2250b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/page-list.vue
// module id = 776
// module chunks = 0